// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2VurR","inputWrap":"Table_inputWrap__1X_qn","col":"Table_col__3CdIY","bmiTooltip":"Table_bmiTooltip__28_ws"};